/**
 * A stable, opaque id for this browser.
 *
 * `auth.guest` takes it so a guest who reloads the page keeps the same stats row instead of
 * spawning a fresh one. It is not a credential and the server never treats it as proof of
 * identity — the session cookie is the only thing that authenticates.
 */

const STORAGE_KEY = 'chompdome-device-id';

export function getDeviceId(): string | undefined {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    // The server's guestSchema bounds this at 8..64 characters; a truncated or hand-edited
    // value would fail input validation, so re-mint rather than send it.
    if (stored && stored.length >= 8 && stored.length <= 64) return stored;

    const minted = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, minted);
    return minted;
  } catch {
    // Private mode, or storage disabled entirely. Guest play still works, it just will not
    // survive a reload — better than refusing to start a match.
    return undefined;
  }
}
